namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1403Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        DocTimeStart: Serenity.TimeEditor;
        DocTimeEnd: Serenity.TimeEditor;
    }

    export class QRywcSpec1403Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1403';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1403Form.init)  {
                QRywcSpec1403Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;
                var w4 = s.TimeEditor;

                Q.initFormType(QRywcSpec1403Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'DocTimeStart', w4,
                    'DocTimeEnd', w4
                ]);
            }
        }
    }
}
